module.exports = __webpack_public_path__ + "img/uncertificate.b712e871.svg";